import React from "react";
import { NewTab, PageTab } from "../../../../../components";
import PersonalDetails from "./H1BviewTabs/PersonalDetails";
import H1BDocuments from "./H1BviewTabs/H1BDocuments";
import PassportAndI94 from "./H1BviewTabs/PassportAndI94";
import Dependents from "./H1BviewTabs/Dependents";
import LinkedH4 from "./H1BviewTabs/LinkedH4";
import Costs from "./H1BviewTabs/Costs";
import OtherH1BRecords from "./H1BviewTabs/OtherH1BRecords";

const H1BViewTabs = () => {
  const H1BViewTabsMenus = [
    {
      title: "Personal Details",
      page: <PersonalDetails />,
      type: "main",
    },

    {
      title: "H-1B Documents",
      page: <H1BDocuments />,
      type: "main",
    },
    {
      title: "Passport & I-94",
      page: <PassportAndI94 />,
      type: "main",
    },
    {
      title: "Dependents",
      page: <Dependents />,
      type: "main",
    },
    {
      title: "Linked H-4",
      page: <LinkedH4 />,
      type: "main",
    },
    {
      title: "Costs",
      page: <Costs />,
      type: "main",
    },
    {
      title: "Other H-1B Records",
      page: <OtherH1BRecords />,
      type: "main",
    },
  ];
  return (
    <div>
      <NewTab
        tabs={H1BViewTabsMenus}
        color="black"
        variant="text"
        activeVariant="text"
      />
    </div>
  );
};

export default H1BViewTabs;
